<template>
  <v-dialog
    v-model="show"
    @click:outside="closeDialog()"
    content-class="dialoghelpTagConfig"
  >
    <span class="text-h5 font-weight-medium text-center my-5">Ayuda</span>
    <span class="text">
      Las etiquetas son un sistema que permite identificar contenido de forma
      óptima, mediante términos y/o expresiones. Por ejemplo:
    </span>
    <span class="text">
      Clave: ciudad
    </span>
    <span class="text botLine">
      Valor: Bogota / Medellin / Cali
    </span>
    <v-btn
      max-width="fit-content"
      class="button-tertiary"
      @click="closeDialog()"
      >Entendido</v-btn
    >
  </v-dialog>
</template>
<script>
export default {
  props: ["show"],
  methods: {
    closeDialog() {
      this.$emit("closeDialog", false);
    },
  },
};
</script>
<style lang="scss">
.v-dialog {
  &.dialoghelpTagConfig {
    background: #ffffff;
    max-width: 550px;
    position: relative;
    padding: 10px 30px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    flex-direction: column;
    .text {
      font-size: 14px;
      font-weight: 500;
      margin-bottom: 12px;
      text-align: center;
      &.botLine {
        border-bottom: 1px solid #e3e4e6;
        padding: 0 0 15px 0;
      }
    }
  }
}
</style>
